import { useMutation, useQueryClient } from '@tanstack/react-query';
import { optInFeaturesQueryKeys } from '../Constants/queryKeys';
import { OptInKeyHeldByDeletedError } from '../Services/OptInFeatures.errors';
import { createOptInFeature } from '../Services/OptInFeatures.service';
import type { OptInFeatureCreatePayload } from '../Types/OptInFeatures.types';
import { useActionToast } from '@/Hooks/useActionToast';

export const useCreateOptInFeature = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: (payload: OptInFeatureCreatePayload) => createOptInFeature(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: optInFeaturesQueryKeys.lists() });
      toast.success('Funcionalidade criada');
    },
    onError: (error: Error) => {
      /*
        The key being held by a DELETED feature is not a failure to report and forget: it has one
        useful answer, which is to restore that feature. The caller opens the dialog that offers
        it, so this one error is swallowed here.
      */
      if (error instanceof OptInKeyHeldByDeletedError) return;

      toast.failure('Não foi possível criar a funcionalidade', error);
    },
  });
};
